module.exports = __webpack_public_path__ + "static/media/light-theme-milage.36a9181f.svg";